import React, { useEffect, useState, useCallback } from 'react';
import GroupEmailManagementTable from './GroupEmailManagementTable';
import GroupEmailManagementTableTopBar from './GroupEmailManagementTableTopBar';
import { fetchAllGroupEmailManagements } from '../GroupEmailManagementAPI';
import {useError} from "../../../Context/ErrorContext/ErrorContext";
import {Box} from "@chakra-ui/react";

const GroupEmailManagementContainer = () => {
    const [groupEmails, setGroupEmails] = useState([]);
    const [filterOptions, setFilterOptions] = useState({});
    const [error, setError] = useState('');
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [fetchTrigger, setFetchTrigger] = useState(false);
    const [refreshFlag, setRefreshFlag] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const { handleError } = useError();

    const refetchGroupEmailManagementData = useCallback(async (options = {}) => {
        setDataLoaded(false);
        try {
            const data = await fetchAllGroupEmailManagements(pageNumber, 10, filterOptions, handleError);
            console.log(data)
            setGroupEmails(data.groupEmails);
            setTotalPages(data.totalPages);
            setError('');
            setDataLoaded(true);
        } catch (error) {
            setError(error.message);
            setGroupEmails([]);
            setTotalPages(0);
        }
    }, [pageNumber, filterOptions, handleError]);

    useEffect(() => {
        refetchGroupEmailManagementData();
    }, [fetchTrigger, refreshFlag, totalPages, fetchTrigger, filterOptions]);

    if (!groupEmails) {
        return (
            <Box textAlign="center" my="4" p="4" color="red.600" bg="blue.50">
                <p>Loading group emails ...</p>
            </Box>
        );
    }

    return (
        <>
            <GroupEmailManagementTableTopBar
                refetchGroupEmailManagementData={refetchGroupEmailManagementData}
                setPageNumber={setPageNumber}
                setFilterOptions={setFilterOptions}
                setFetchTrigger={setFetchTrigger}
            />
            <GroupEmailManagementTable
                groupEmails={groupEmails}
                setGroupEmails={setGroupEmails}
                error={error}
                pageNumber={pageNumber}
                setRefreshFlag={setRefreshFlag}
                setPageNumber={setPageNumber}
                totalPages={totalPages}
                setTotalPages={setTotalPages}
                filterOptions={filterOptions}
                dataLoaded={dataLoaded}
                refetchGroupEmailManagementData={refetchGroupEmailManagementData}
            />
        </>
    );
};

export default GroupEmailManagementContainer;
